import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { Link } from 'react-router'
import { useMediaQuery } from 'usehooks-ts'

import { BannerInfo } from '@shared/generated'

import styles from './styles.module.scss'

interface BannerCarouselProps {
  banners: BannerInfo[] | null;
  loading?: boolean;
}

function BannerSkeleton () {
  return (
    <SkeletonTheme>
      <Skeleton
        width={'100%'}
        style={{
          borderRadius: 12,
          aspectRatio: '2.8/1',
          minHeight: '180px',
        }}
      />
    </SkeletonTheme>
  )
}

function BannerItem ({ banner }: { banner: BannerInfo }) {
  const isTablet = useMediaQuery('(max-width: 768px')

  const bannerImg = (isTablet ? banner.bannerMobileSlide?.url : banner.bannerSlide?.url) ?? banner.bannerSlide?.url
  const bannerLink = banner.url

  return <div className={styles.item}>
    {bannerLink ?
      <Link to={bannerLink}>
        {bannerImg && <img src={bannerImg} alt={banner.name ?? ''} />}
      </Link>
      : <>{bannerImg && <img src={bannerImg} alt={banner.name ?? ''} />}</>
    }
  </div>
}

export default function BannerGrid (props: BannerCarouselProps) {
  const { banners = [], loading } = props

  if (loading) {
    return <BannerSkeleton />
  }

  return <div className={styles.root}>
    {banners?.map(banner => <BannerItem banner={banner} />)}
  </div>
}